<script>

import { mapState } from 'vuex'
import formatMixin from '../../mixins/formatMixin';

export default {
	mixins: [formatMixin],
	props: {
		mensagem: String,
		isCustomerTypeSale: Number,
		customer: Object,
		paymentConditions: Array,
		discountCoupons: Array,
		minimumInstallmentPrice: Number,
		hasSelectPaymentConditions: Boolean,
		hasDiscountCoupons: Boolean,
        allProducts: Array,
		blockedProducts: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			observacoes: '',
			paymentCondition: null,
			loading: false,
			showCupons: false,
			filteredPaymentConditions: [],
			totalOrder: 0,
			totalCampaignDiscount: 0,			
			totalDiscountPaymentCondition: 0,
			totalDiscountCoupon: 0,
			coupons: [],
			totalOrderWithDiscounts: 0,
            allProducts: [],
		};
	},
	computed: {
        ...mapState({
			campaigns: state => state.cart.campaigns,
        	products: state => state.cart.products,
        	isLoading: state => state.cart.isLoading
        }),
		totalPriceProducts() {
			let totalPriceProducts = 0;

			this.products.forEach((product) => {
				totalPriceProducts += (product.price * product.quantidade);
			});

			return totalPriceProducts;
		},		
		selectedPaymentCondition() {			
			return this.filteredPaymentConditions.filter(
				paymentCondition => paymentCondition.cod_cond_pagto === this.paymentCondition
			).shift();
		},		
		hasCampaignPaymentCondition() {
			return this.selectedPaymentCondition && this.selectedPaymentCondition.campaign_payment_condition;
		},		
		getDiscountPaymentConditionWithoutProduct() {
			const paymentCondition = this.selectedPaymentCondition;

			let discountPercentage = 0;

			if (paymentCondition) {
				discountPercentage += parseFloat(paymentCondition.discount_percentage);

				if (paymentCondition.campaign_payment_condition && !paymentCondition.campaign_payment_condition.products.length) {
					discountPercentage += parseFloat(paymentCondition.campaign_payment_condition.discount_percent);
				}
			}

			return discountPercentage;
		},
		getDiscountCampaignsWithoutProduct() {
			if (!this.campaigns || !this.campaigns.length) {
				return 0;
			}

			let discountPercentage = 0;

			this.campaigns.forEach((campaign) => {
				if (campaign.products.length) {
					return;
				}

				discountPercentage += parseFloat(campaign.discount_percent);
			});

			return discountPercentage;
		},
		getDiscountCouponWithoutProduct() {
			let discountPercentage = 0;

			const couponWithoutProduct = this.coupons.filter(coupon => !coupon.products.length && coupon.applied).shift();
			
			if (couponWithoutProduct) {
				discountPercentage = parseFloat(couponWithoutProduct.discount_percent);
			}

			return discountPercentage;
		},				
    },		
	watch: {
		products() {
			this.calculateTotalOrder();
			this.calculateDiscounts();

			if (this.hasDiscountCoupons) {
				this.coupons = this.getDiscountCoupons();		
			}		
		},
		totalOrder(newValue) {
			if (!this.hasSelectPaymentConditions || !this.isCustomerTypeSale) {
				return;
			}

			this.filterPaymentConditions(newValue);
		},
		paymentCondition() {
			if (!this.isCustomerTypeSale) {
				return;
			}

			this.calculateTotalOrder();
			this.calculateDiscounts();
		},
		coupons() {
			if (!this.isCustomerTypeSale) {
				return;
			}

			this.calculateTotalOrder();
			this.calculateDiscounts();
		},
	},	
	methods: {	
		calculateTotalOrder() {
			let totalOrder = 0;

			this.products.forEach((product) => {
				totalOrder += (product.price * product.quantidade);
			});

			totalOrder += this.totalTax('st') + this.totalTax('ipi');

			this.totalOrder = totalOrder;
		},
		calculateDiscounts() {
			let totalDiscountPaymentCondition = 0;
			let totalDiscountCampaigns = 0;			
			let totalDiscountCoupons = 0;
		
			this.products.forEach(product => {
				const discountPaymentCondition = this.getDiscountPercentagePaymentCondition(product);
				const discountCampaigns = this.getDiscountPercentageCampaigns(product);
				const discountCoupons = this.getDiscountPercentageCoupons(product);
				
				let productWithDiscount = this.calculateDiscountProduct(
					product.price, 
					discountPaymentCondition.discountsHeader, 
					0, 
					discountPaymentCondition.discountProduct
				);	

				totalDiscountPaymentCondition += (product.price - this.roundValue(productWithDiscount)) * product.quantidade;

				let beforeDiscount = this.roundValue(productWithDiscount);

				productWithDiscount = this.calculateDiscountProduct(
					productWithDiscount, 
					0, 
					discountCampaigns.discountsHeader, 
					discountCampaigns.discountProduct
				);

				totalDiscountCampaigns += (beforeDiscount - this.roundValue(productWithDiscount)) * product.quantidade;	

				beforeDiscount = this.roundValue(productWithDiscount);

				productWithDiscount = this.calculateDiscountProduct(
					productWithDiscount, 
					0, 
					discountCoupons.discountsHeader, 
					discountCoupons.discountProduct
				);

				totalDiscountCoupons += (beforeDiscount - this.roundValue(productWithDiscount)) * product.quantidade;				
			});

			this.totalOrderWithDiscounts = this.totalOrder;

			this.totalDiscountPaymentCondition = totalDiscountPaymentCondition;
			this.totalCampaignDiscount = totalDiscountCampaigns;
			this.totalDiscountCoupon = totalDiscountCoupons;

			this.totalOrderWithDiscounts -= (this.totalDiscountPaymentCondition + this.totalCampaignDiscount + this.totalDiscountCoupon);
		},				
		netPrice(product) {					
			const discountPaymentCondition = this.getDiscountPercentagePaymentCondition(product);
			const discountCampaigns = this.getDiscountPercentageCampaigns(product);			
			const discountCoupons = this.getDiscountPercentageCoupons(product);

			const discountD2 = discountPaymentCondition.discountsHeader;
			const discountD4 = discountCampaigns.discountsHeader + discountCoupons.discountsHeader;
			const discountProduct = discountCampaigns.discountProduct + discountCoupons.discountProduct + discountPaymentCondition.discountProduct;

			const priceWithDiscount = this.calculateDiscountProduct(product.price, discountD2, discountD4, discountProduct);
			
			return this.roundValue(priceWithDiscount);
		},	
		calculateDiscountProduct(value, discountD2, discountD4, discountProduct) {
			let price = this.precision(value - (value * (discountD2 / 100)));
			price = this.precision(price - (price * (discountD4 / 100)));
			price = this.precision(price - (price * (discountProduct / 100)));

			return price;
		},
		getDiscountPercentageCampaigns(product) {			
			const discountsHeader = this.getDiscountCampaignsWithoutProduct;		
			let discountProduct = 0;

			if (this.campaigns && this.campaigns.length) {
				const campaign = this.campaigns.filter(campaign => {
					return campaign.products.some(p => p.id === product.produto_id);
				}).shift();

				if (campaign) {
					discountProduct = parseFloat(campaign.discount_percent);
				}
			}
			
			const totalDiscount = discountsHeader + discountProduct;

			return { discountsHeader, discountProduct, totalDiscount};
		},
		getDiscountPercentagePaymentCondition(product) {	
			const paymentCondition = this.selectedPaymentCondition;

			if (!paymentCondition) {
				return { discountsHeader: 0, discountProduct: 0, totalDiscount: 0};
			}

			const discountsHeader = this.getDiscountPaymentConditionWithoutProduct;
			
			const campaignPaymentCondition = paymentCondition.campaign_payment_condition;

			let discountProduct = 0;

			if (campaignPaymentCondition && campaignPaymentCondition.products.length) {
				const p = campaignPaymentCondition.products.find(p => p.id === product.produto_id);

				if (p) {
					discountProduct = campaignPaymentCondition.discount_percent;
				}
			}

			const totalDiscount = discountsHeader + discountProduct;

			return { discountsHeader, discountProduct, totalDiscount};
		},
		getDiscountPercentageCoupons(product) {
			const discountsHeader = this.getDiscountCouponWithoutProduct;

			let discountProduct = 0;

			const couponWithProduct = this.coupons.filter(coupon => {
				return coupon.products.length && coupon.applied && coupon.products.some(p => p.id === product.produto_id);
			}).shift();

			if (couponWithProduct) {
				discountProduct = parseFloat(couponWithProduct.discount_percent);
			}

			const totalDiscount = discountsHeader + discountProduct;

			return { discountsHeader, discountProduct, totalDiscount};
		},		
		totalTax(typeTax) {			
			let totalPriceProducts = 0;
			let total = 0;
						
			this.products.forEach((product) => {
				let tax = 0;

				switch (typeTax) {
					case 'ipi':
						tax = product.ipi;
						break;
					case 'st':
						tax = product.st;
						break;
				}

				const price = this.netPrice(product);

				totalPriceProducts = price * product.quantidade;
				totalPriceProducts = (totalPriceProducts * (parseFloat(tax)) / 100);

                total += totalPriceProducts;
			});

			total = this.precision(total);
			total = this.roundValue(total);

			return total;
		},															
		totalPriceItem(product, taxes = false) {
			let price = 0;

			price = this.netPrice(product);
			price = price * product.quantidade;						

			if (taxes) {
				price = (price * (100 + parseFloat(product.ipi) + (parseFloat(product.st)))) / 100
			}

			return price;
		},				
		filterPaymentConditions(totalOrder) {
			let numberInstallments = parseInt(totalOrder / this.minimumInstallmentPrice);
			numberInstallments = numberInstallments === 0 ? 1 : numberInstallments;
			
			this.filteredPaymentConditions = this.paymentConditions.filter(
				paymentCondition => paymentCondition.number_installments <= numberInstallments
			);

			this.selectPaymentConditionFirstRender();
		},
		selectPaymentConditionFirstRender() {
			if (this.paymentCondition) {
				return;
			}
			
			const hasCustomerPaymentCondition = this.filteredPaymentConditions.some(
				paymentCondition => paymentCondition.cod_cond_pagto === this.customer.cond_pagamento
			);

			if (hasCustomerPaymentCondition) {
				this.paymentCondition = this.customer.cond_pagamento;

				return;
			}

			let paymentCondition = this.filteredPaymentConditions.shift()
			this.paymentCondition = paymentCondition.cod_cond_pagto;
		},					
		getDiscountCoupons() {			
			return this.discountCoupons.map(discountCoupon => {
				discountCoupon['applicable_coupon'] = this.applicableCoupon(discountCoupon);
				discountCoupon['applied'] = false;				

				return discountCoupon;
			});
		},
		applyCoupon(coupon) {
			let couponsWithProductsAlreadyApplied = [];

			if (!coupon.products.length) {			
				this.coupons = this.coupons.map(c => {
					if (c.id !== coupon.id && !c.products.length) {
						c['applied'] = false;
					}

					return c;
				});
			}

			if (coupon.products.length) {
				const productsIds = [];
				
				coupon.products.forEach(product => {
					productsIds.push(product.id);
				}); 

				couponsWithProductsAlreadyApplied = this.coupons.filter(c => {
					return c.applied && c.products.some(p => productsIds.includes(p.id));
				});			
			}
			
			this.coupons = this.coupons.map(c => {
				if (c.id === coupon.id) {
					c['applied'] = true;					
				}

				const hasProductApplied = couponsWithProductsAlreadyApplied.some(cwpaa => c.id === cwpaa.id);

				if (
					hasProductApplied || 
					(!coupon.products.length && c.id !== coupon.id && c.products.length) || 
					(coupon.products.length && c.id !== coupon.id && !c.products.length)
				) {
					c['applied'] = false;
				}

				return c;
			}); 
		},
		removeCoupon(coupon) {
			this.coupons = this.coupons.map(c => {
				if (c.id === coupon.id) {
					c['applied'] = false;					
				}

				return c;
			}); 
		},
		applicableCoupon(discountCoupon) {
			let applicableCoupon = false;

			if (!discountCoupon.products.length) {
				applicableCoupon = true;
			}

			if (discountCoupon.products.length) {
				const cartProducts = this.products;

				applicableCoupon = discountCoupon.products.every(product => {
					return cartProducts.some(cartProduct => cartProduct.produto_id === product.id);
				});
			}

			return applicableCoupon;
		},
		formatValue(value) {
        	return value.toString().replace('.', ',');
        },				
		roundValue(value) {			
			return Math.round((value + Number.EPSILON) * 100) / 100
		},			
		precision(value, precision = 4) {
			const power = Math.pow(10, precision);
			const absValue = Math.abs(Math.round(value * power));
			let result = (value < 0 ? '-' : '') + String(Math.floor(absValue / power));

			const fraction = String(absValue % power);
			const padding = new Array(Math.max(precision - fraction.length, 0) + 1).join('0');

			result += '.' + padding + fraction;

			return parseFloat(result);
		},
		async checkQuantity(produto) {		
			try {
				await this.$store.dispatch('cart/checkQuantityProduct', produto);

				this.$toasted.success('Produto atualizado', {
					duration:3000, 
					keepOnHover: true
				});
			} catch (error) {
				this.$toasted.error(error, {
					duration:3000, 
					keepOnHover: true, 
					icon:'exclamation-circle'
				});
			}
		},
		async incrementa(produto) {
			try {
				await this.$store.dispatch('cart/incrementProduct', produto);
				
				this.$toasted.success('Produto atualizado', {
					duration:3000, 
					keepOnHover: true
				});
			} catch (error) {
				this.$toasted.error(error, {
					duration:3000, 
					keepOnHover: true, 
					icon:'exclamation-circle'
				});
			}
		},
		async decrementa(produto) {
			try {
				await this.$store.dispatch('cart/decrementProduct', produto);

				this.$toasted.success('Produto atualizado', {
					duration:3000, 
					keepOnHover: true
				});
			} catch (error) {
				this.$toasted.error(error, {
					duration:3000, 
					keepOnHover: true, 
					icon:'exclamation-circle'
				});
			}
		},
		async adicionar(produto) {
			try {
				await this.$store.dispatch('cart/addProduct', produto);

				this.$toasted.success('Produto atualizado', {
					duration:3000, 
					keepOnHover: true
				});
			} catch (error) {
				this.$toasted.error(error, {
					duration:3000, 
					keepOnHover: true, 
					icon:'exclamation-circle'
				});
			}
		},
		async remover(produto) {
			try {
				await this.$store.dispatch('cart/removeProduct', produto);

				this.$toasted.success('Produto atualizado', {
					duration:3000, 
					keepOnHover: true
				});
			} catch (error) {
				this.$toasted.error(error, {
					duration:3000, 
					keepOnHover: true, 
					icon:'exclamation-circle'
				});
			}
		},
		async salvarPedido(tipo) {
			this.loading = true;
			let valido = true;

            if (this.products.length > 99 && tipo !== 'cancelado') {
                this.$toasted.show("O pedido possui mais de 99 itens, realize a revisão", {
                    type: "error",
                    duration: 4000
                });

                this.loading = false;
                valido = false;
            }

			if (this.observacoes !== null && this.observacoes.length > 40) {
				this.$toasted.error('Campo observação deve ter no máximo 40 caracteres.', {
					duration:3000, 
					keepOnHover: true, 
					icon:'exclamation-circle'
				});

				this.loading = false;
				valido = false;
			}

			if (this.isCustomerTypeSale && !this.selectedPaymentCondition) {
				this.$toasted.error('Campo condição de pagamento é obrigatório.', {
					duration:3000, 
					keepOnHover: true, 
					icon:'exclamation-circle'
				});
				
				this.loading = false;
				valido = false;
			}

			if (!valido) {
				return;
			}

			let clientesRelacionados = [];

			$('input[name="clientes_relacionados[]"]:checked').each(function() {
				clientesRelacionados.push($(this).val());
			});

			if (clientesRelacionados.length == 0) {
				this.$toasted.error('Seleciona ao menos um cliente.', {
					duration:3000, 
					keepOnHover: true, 
					icon:'exclamation-circle'
				});

				this.loading = false;

				return;
			}

			try {
				let coupons = this.coupons.filter(coupon => coupon.applied);
				coupons = coupons.map(coupon => coupon.id)

				const response = await this.axios.post(API_URL + "/novo-pedido/pedido/salvar-pedido", {
					produtos: this.products,
					observacoes: this.observacoes,
					status: tipo,
					relacionados: clientesRelacionados,
					paymentCondition: this.selectedPaymentCondition,
					coupons: coupons,
				});

				if (response.data != '0')  {
					window.location.href = APP_URL + '/meus-pedidos/detalhes/' + response.data.id;
				} else {
					window.location.href = APP_URL + '/novo-pedido/checkout';
				}
				
				this.products = [];						
				this.loading = false;

			} catch (error) {
				const response = error.response;

				if (response.status === 409) {

					if(response.data.blockedProducts) {

						this.blockedProducts = response.data.blockedProducts;
						this.handleBlockeProduct()
						this.loading = false;
						return;
						
					}
					
					this.$toasted.error(response.data.message, {
						duration:3000, 
						keepOnHover: true, 
						icon:'exclamation-circle'
					});

					this.loading = false;

					return;
				}

				this.$toasted.error('Falha ao salvar o Pedido.', {
					duration:3000, 
					keepOnHover: true, 
					icon:'exclamation-circle'
				});

				this.loading = false;
			}	 	
		},
		handleBlockeProduct() {
			if(this.blockedProducts.length > 0) {
                this.$fire({
                    title: 'Erro de validação!',
                    text: 'Os seguintes produtos estão indisponíveis',
                    html: `
                    <p> Os seguintes produtos estão indisponíveis: </p>
                    <br>
                    <ul>
                        ${this.blockedProducts.map(product => `<li style="margin-bottom: 5px">${product}</li>`).join('')}
                    </ul>
                    <br>
                    <p>Por favor, remova-os para seguir com o pedido.</p>
                    `,
                    type: 'error',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false,
                    customClass:   {
                        title: 'notification-alert-title',
                        confirmButton: 'notification-alert-confirm',
                        content: 'notification-alert-text'
                    }
                })
		    }			
		}	
	},
	created() {		
		this.observacoes = this.mensagem;
		this.handleBlockeProduct()
	},
    mounted() {
        if (this.allProducts.length > 99) {
            this.$toasted.show("O pedido possui mais de 99 itens, realize a revisão", {
                type: "error",
                duration: 15000
            });
        }
        
        if (this.removedProductsWarning && this.removedProductsWarning.length > 0) {
            let message = 'Item indisponível removido do pedido, contate o seu representante: <br>'

            if (this.removedProductsWarning.length > 1) {
                message = 'Itens indisponíveis removidos do pedido, contate o seu representante: <br>'
            }

            this.removedProductsWarning.forEach(function(productReference) {
				message += productReference + '<br>';
			})

            this.$toasted.show(message, {
                type: "error",
                duration: null,
                singleton: true,
                action : {
                    text : 'Fechar',
                    onClick : (e, toastObject) => {
                        toastObject.goAway(0)
                    }
                },
            });
        }
    }
};
</script>